module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mntrelm5-3cf01f5a60ca58ebc04175abb0d4bc45.jpg";